<template>
    <v-card>
        <v-card-title>
            <span class="headline">Agregar horario de atención</span>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" class="font-weight-bold">
                    Agregue el horario de atención disponible
                </v-col>
                <v-col cols="12" >
                    <v-select
                        v-model="select"
                        label="Selecione Horario"
                        :items="horarios"
                        item-value="id"
                        item-text="label"
                        @input="(payload) => form.horario_id = payload"
                    ></v-select>
                </v-col>
            </v-row>
        </v-card-text>

        <v-card-actions>
            <v-spacer/>
            <v-btn
                color="gray darken-1"
                @click="$emit('close', true)"
            >
                Cancelar
            </v-btn>
            <v-btn
                v-if="button_active"
                color="blue darken-1"
                class="white--text"
                @click="guardarHorarioAtencion"
            >
                Guardar
            </v-btn>
            <v-btn
                v-if="!button_active"
                color="blue darken-1"
                class="white--text"
                disabled
            >
                Cargando...
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "FormDiaAtencion",
        props: ["horarios", "dia_horario"],
        data() {
            return {
                form: {
                    horario_id: this.dia_horario ? this.dia_horario.horario_id : null
                },
                button_active: true,
                loading: false,
                mostrar_alert: false,
                select: {label: this.label, id: this.dia_horario.horario_id},
            }
        },
        methods: {
            guardarHorarioAtencion(){
                this.button_active = false
                axios.put(`/api/dias-atencion/${this.dia_horario.id}`, {
                    ...this.form
                }).then(() => {
                    this.button_active = true
                    this.$emit('close', true)
                    this.$emit('listar')
                }).catch(error => {
                    this.$emit('close', true)
                    this.button_active = true
                    window.console.log(error)
                })
            }
        },
        mounted() {
            
        },
    }
</script>

<style scoped>

</style>
